import { ReactElement } from 'react'
import { Form2 } from '@ui/forms'
import FormFields from '../FormFields'
import { planSettingsValidationSchema } from '../planSettingsValidationSchema'
import PlanSettingsScenePreview from './components/PlanSettingsScenePreview'

interface Props {
  planSettings: PdfPlanSettings
  onPlanSettingsChange: (planSettings: PdfPlanSettings) => void
  formId?: string
}

const PlanSettingsForm = ({
  planSettings,
  onPlanSettingsChange,
  formId = 'plan-settings-form',
}: Props): ReactElement => {
  return (
    <Form2
      id={formId}
      key={JSON.stringify(planSettings)}
      onSubmit={onPlanSettingsChange}
      defaultValues={planSettings}
      validationSchema={planSettingsValidationSchema}
      submitOnChange
    >
      <FormFields />
      <PlanSettingsScenePreview />
    </Form2>
  )
}

export default PlanSettingsForm
